<div class="flex flex-col gap-4">
  @for (entry of entries(); track entry) {
    <app-shipsan-regulation-lookup [field]="entry" [index]="$index" />
  }
  @if (!state().disabled()) {
    <button
      type="button"
      class="self-start text-left text-sm font-semibold text-button-secondary-color hover:underline"
      data-testid="shipsan-add-item"
      (click)="addItem()">
      + Add ShipSan item
    </button>
  }
</div>
